export function withFontOffset(size: number | `${number}px`, extra = 0) {
  const extraExpr = extra === 0 ? '' : ` + ${extra}px`;

  return typeof size === 'number'
    ? `calc(${size}px + var(--app-font-size-offset)${extraExpr})`
    : `calc(${size} + var(--app-font-size-offset)${extraExpr})`;
}

export function withVisualFontOffset(size: number | `${number}px`) {
  const numericSize = typeof size === 'number' ? size : Number.parseFloat(size);
  const ratio = numericSize >= 32 ? 0.6 : numericSize >= 24 ? 0.75 : numericSize >= 18 ? 0.9 : 1;
  const adaptiveExtra = `calc(var(--app-font-size-offset) * ${ratio})`;

  return typeof size === 'number'
    ? `calc(${size}px + var(--app-font-size-offset) + ${adaptiveExtra})`
    : `calc(${size} + var(--app-font-size-offset) + ${adaptiveExtra})`;
}

export function getVisualTextStack(height: number, hasPrediction: boolean) {
  if (hasPrediction) {
    return {
      nameY: Math.round(height * 0.28),
      valueY: Math.round(height * 0.56),
      predictY: Math.round(height * 0.8),
    };
  }

  return {
    nameY: Math.round(height * 0.4),
    valueY: Math.round(height * 0.7),
  };
}

export function getVisualCenterY(height: number) {
  return Math.round(height / 2);
}
